export default __webpack_public_path__ + "static/media/logo_wide-preview.33e41478.png";